/**
 * External dependencies
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
class Topbar extends Component {
	static propTypes = { children: PropTypes.array };

	render() {
        const { children, className, ...rest } = this.props;
		return (
			<div className={classNames('topbar', className)} data-tip-target='topbar' {...rest}>
				{children}
			</div>
		);
	}
}
export default Topbar;
